module.exports = __webpack_public_path__ + "img/calculator.828b94a0.svg";